import React, { useEffect, useState } from 'react';
import { selectWindowType, WindowTypes } from 'store/pageStore';
import { useSelector } from 'react-redux';
import { checkScreenType } from 'utils';
import {
	Modal,
	ModalContent,
	ModalFooter,
	ModalHeader,
	RegularButton,
	Typography,
} from 'fronton-react';
import { selectRoughWorkNetwork, selectLeadId } from '../selectors';
import { Form } from './form';
import { applicationStatusList } from './application-db';
import {
	formContainerStyles,
	fromLeftStyles,
	fromRightStyles,
	formDescriptionStyles,
} from './styles';

export const ApplicationForm = () => {
	const [applicationStatus, setApplicationStatus] = useState('success');
	const applicationNetwork = useSelector(selectRoughWorkNetwork);
	const leadId = useSelector(selectLeadId);
	const [openModal, setOpenModal] = useState(false);
	const toggleModal = () => setOpenModal(!openModal);
	const screenType = useSelector(selectWindowType);
	const isMobile = checkScreenType(screenType, WindowTypes.mobile);
	useEffect(() => {
		if (leadId && !applicationNetwork.isFailed && !applicationNetwork.isFetching) {
			setApplicationStatus('success');
			return toggleModal();
		}
		if (
			applicationNetwork.isFailed &&
			JSON.parse(applicationNetwork.error?.message).errors.find(el => el.code === 109)
		) {
			setApplicationStatus('duplicate');
			return toggleModal();
		}
		if (applicationNetwork.isFailed) {
			setApplicationStatus('error');
			return toggleModal();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [leadId, applicationNetwork]);
	return (
		<>
			<div className={formContainerStyles} id="applicationForm">
				<div className={fromLeftStyles}>
					<Typography variant="h2">
						Заявка на бесплатную <br /> консультацию
					</Typography>
					<Typography
						className={formDescriptionStyles}
						variant={isMobile ? 'm' : 'l'}
						size="body_short"
					>
						Отправьте заявку, мы проконсультируем вас по стоимости, списку работ и
						срокам.
						<br /> Запишем на замер
					</Typography>
					<img src="https://cdn.lemanapro.ru/lmru/image/upload/v1725886105/fudzi/elbrus/images/landings/rough-work/_Arrowrightlong.png/_Arrowrightlong.png" />
				</div>
				<div className={fromRightStyles}>
					<Form />

					<Typography variant="caption">
						Нажимая на кнопку «Отправить», вы принимаете{' '}
						<a href="https://lemanapro.ru/pravila/" target="_blank" role="link">
							Положение
						</a>{' '}
						и{' '}
						<a
							href="https://lemanapro.ru/legal/soglasie-na-obrabotku-personalnyh-dannyh/"
							target="_blank"
							role="link"
						>
							Согласие
						</a>{' '}
						и на обработку персональных данных, в соответствии с{' '}
						<a
							href="https://lemanapro.ru/legal/politika-obrabotki-personalnykh-dannykh/?utm_referrer=https%3A%2F%2Flemanapro.ru%2Fuslugi%2Fgotovye-resheniya-pod-klyuch%2Fmehanizirovannaya-shtukaturka-sten%2F%3Futm_referrer%3Dhttps%253A%252F%252Fweb.telegram.org%252F"
							target="_blank"
							role="link"
						>
							Политикой
						</a>
					</Typography>
				</div>
			</div>
			<Modal modalID="menu" show={openModal} onClose={toggleModal} size="s">
				<ModalHeader title={applicationStatusList[applicationStatus].title} />
				<ModalContent>{applicationStatusList[applicationStatus].text}</ModalContent>
				<ModalFooter>
					<RegularButton size="l" variant="primary" wide onClick={toggleModal}>
						{applicationStatusList[applicationStatus]?.action}
					</RegularButton>
				</ModalFooter>
			</Modal>
		</>
	);
};
